var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "blog-wrapper" },
    [
      _c("Banner"),
      _vm._v(" "),
      _c("div", { staticClass: "top-title" }, [
        _vm._v("\n" + _vm._s(_vm.t("blog.top_title")) + "\n"),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "blog-list" },
          [
            _c("div", { staticClass: "row justify-content-center" }, [
              _c("div", { staticClass: "col-12" }, [
                _vm.list.length
                  ? _c("div", { staticClass: "row" }, [
                      _c("h3", [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm.t("blog.all_title")) +
                            "\n          "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "col-12 col-lg-8" },
                        _vm._l(_vm.list, function (item, index) {
                          return _c(
                            "router-link",
                            {
                              key: index,
                              attrs: {
                                to: _vm.getBlogLink(item),
                                target: "_blank",
                              },
                            },
                            [
                              _c("div", { staticClass: "blog-card" }, [
                                _c("img", {
                                  attrs: { src: item.signBannerUrl },
                                }),
                                _vm._v(" "),
                                _c("h4", [_vm._v(_vm._s(item.title))]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.t("blog.update_date")) +
                                      " " +
                                      _vm._s(item.createDate)
                                  ),
                                ]),
                              ]),
                            ]
                          )
                        }),
                        1
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
            _vm._v(" "),
            _c("Pager", {
              attrs: {
                current: _vm.page,
                max: _vm.totalPage,
                prefix: "/blog/all",
              },
            }),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }